import _ from 'lodash';
import moment from 'moment';
import { ERROR_DELETE_MESSAGE } from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { suitableTime } from '../../utils/suitableDate'
import { deleteSupport } from '../../apis/backend';

export const initSupport = async (newProps, component) => {
  const { shopId, support } = newProps;
  const { clients } = component.state;
  const listComplains = [];
  if (support) {
    _.map(support, (complains, userId) => {
      if (clients?.data[userId]) {
        _.map(complains, (complain, complainId) => {
          if (complain.shopId === shopId && complain.reason !== 'product_unreceived') {
            const { date: dateComplain = '', issues = '', order = {}, reason = '' } = complain;
            const {
              userNameDep = '',
              orderNumber,
              date: orderDate = '',
              firstName = '',
              lastName = '',
              numero: number = ''
            } = order;
            const orderTime = suitableTime(moment(orderDate));
            const complainTime = suitableTime(moment(dateComplain));
            listComplains.push({
              firstName,
              userNameDep,
              number,
              issues,
              orderNumber,
              lastName,
              reason,
              orderDate,
              dateComplain,
              orderTime,
              complainTime,
              userId,
              complainId
            });
          }
        });
      }
    });
  }
  component.setState({
    supportData: listComplains.sort((a, b) => moment(b.dateComplain) - moment(a.dateComplain)),
    isLoading: false
  });
};

export const handleSubmit = async (support, component) => {
  const { openErrorModal, showModal } = component.props;
  const { userId, complainId } = support;
  try {
    showModal({
      color: 'danger',
      title: `Êtes-vous sûr(e) de vouloir supprimer ce message ?`,
      loading: true
    });
    await deleteSupport(userId, complainId)
  } catch (e) {
    sendCloudWatchAlert(`Error when deleting message ${e}`);
    openErrorModal(ERROR_DELETE_MESSAGE);
  }
  showModal(null);
};

export const handleRemoveMessage = (event, e, component) => {
  event.stopPropagation();
  const { showModal } = component.props;
  const modalData = {
    color: 'danger',
    title: 'Etes vous sûr(e) de vouloir supprimer ce message ?',
    showCancelBtn: true,
    btnColor: 'danger',
    onClick: () => {
      handleSubmit(e, component);
    },
    btnTxt: 'Supprimer'
  };
  showModal(modalData);
};

export const closeModal = component => {
  component.setState({ showSupportModal: false });
};

export const handleRowClick = component => {
  component.setState({ showSupportModal: true });
};
